let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jtcRz")).then(() => parcelRequire('h5al3'));